import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const sessionInformation202409: BlogMetaData = {
  title: '2024年9月の説明会開催について',
  description: '今年度及び来年度の園児募集につき、保育園の説明会を開催します。',
  thumbnailUrl: '/img/first-view-image1.webp',
  filePath: buildBlogFilePath('2024_9-session-information'),
  category: BLOG_CATEGORY.NEWS,
};
